'use client';

import React, { type ReactNode } from 'react';

import FloatingButton from '../../components/FloatingButton';
import GlobalToastContainer from '../../components/GlobalToastContainer';
import InAppReviewTrigger from '../../components/in-app-review/InAppReviewTrigger';
import MarketingConsentModal from '../../components/marketing-consent/MarketingConsentModal';
import PCHeader from '../../components/PCHeader';
import ReactNativeListener from '../../components/ReactNativeListener';
import RenewalFooter from '../../components/RenewalFooter';
import RenewalTopNavBar from '../../components/RenewalTopNavBar';
import WebToAppInstallModal from '../../components/web-to-app/WebToAppInstallModal';
import AlertModal from '../../Member/components/AlertModal';
import BottomNavigation from '../../Member/components/BottomNavigation';
import GlobalModal from '../../Member/components/GlobalModal';
import MarketAddCartCompleteSheet from '../../Member/components/ustore/cart-complete/MarketAddCartCompleteSheet';
import { useAlertModalStore } from '../../store/alertModalStore';
import { useGlobalModalStore } from '../../store/globalModalStore';
import { isStageDev } from '../../utils/common';
import useToggleLayout from '../../utils/hook/useToggleLayout';

import LayoutExternalLibraries from './LayoutExternalLibraries';
import { LayoutNavigationEvents } from './LayoutNavigationEvents';
import LayoutPortal from './LayoutPortal';
import LayoutUglyusDevTool from './LayoutUglyusDevTool';

const LayoutChildrenWrapper = ({ children }: { children: ReactNode }) => {
  const alertModal = useAlertModalStore.use.alertModal();
  const globalModal = useGlobalModalStore.use.globalModal();
  const { showMobileHeader, showPCHeader, showFooter } = useToggleLayout();

  return (
    <>
      <LayoutNavigationEvents />

      <LayoutExternalLibraries />

      <ReactNativeListener />

      <GlobalToastContainer />

      <div className="flex min-h-screen flex-col font-pretendard">
        {showPCHeader && <PCHeader />}
        {showMobileHeader && <RenewalTopNavBar />}

        {/* flex 기둥으로 두어 풀높이 페이지가 grow만으로 잔여 높이를 채우게 한다(크롬 높이 재계산 불필요) */}
        <main className="flex flex-1 flex-col">{children}</main>

        {alertModal && <AlertModal {...alertModal} />}
        {globalModal && <GlobalModal {...globalModal} />}
        <MarketAddCartCompleteSheet />
        <WebToAppInstallModal />
        <MarketingConsentModal />
        <InAppReviewTrigger />
        <LayoutPortal />

        <FloatingButton />

        {showFooter && <RenewalFooter />}

        <BottomNavigation />
      </div>

      {/* 어글리어스 개발자도구 */}
      {isStageDev && <LayoutUglyusDevTool />}
    </>
  );
};

export default LayoutChildrenWrapper;
